@if (statistics()?.isLoading || isIframeLoading()) {
    <div class="skeleton-container">
        <div class="skeleton-header"></div>
        <div class="skeleton-content"></div>
    </div>
} @else if (statistics()?.isError || !safeUrl()) {
    <ds-alert type="caution">{{ messages()?.error }}</ds-alert>
}
<iframe
    width="100%"
    [attr.height]="(iframeHeight() ?? playerStatsIframeHeight) + 'px'"
    [attr.src]="safeUrl()"
    [class.iframe-hidden]="isIframeLoading() || !safeUrl()"
    (load)="onIframeLoad()"></iframe>
